import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import {
  Presentation,
  PresentationProperty,
  Theme,
  AffectedDevice,
} from '@raydiant/api-client-js';
import { SortThemeOptions } from '../../utilities';

export const loadPresentationPage = createStandardAction(
  '@PRESENTATION_PAGE/LOAD_PRESENTATION_PAGE',
)<{ presentationId: string }>();

export const loadPresentationPageAsync = createAsyncAction(
  '@PRESENTATION_PAGE/LOAD_PRESENTATION_PAGE_REQUEST',
  '@PRESENTATION_PAGE/LOAD_PRESENTATION_PAGE_SUCCESS',
  '@PRESENTATION_PAGE/LOAD_PRESENTATION_PAGE_FAILURE',
)<void, { affectedDevices: AffectedDevice[] }, Error>();

export const setUnsavedPresentation = createStandardAction(
  '@PRESENTATION_PAGE/SET_UNSAVED_PRESENTATION',
)<Presentation>();

export const clearUnsavedPresentation = createStandardAction(
  '@PRESENTATION_PAGE/CLEAR_UNSAVED_PRESENTATION',
)<string>();

export const clearAllUnsavedPresentations = createStandardAction(
  '@PRESENTATION_PAGE/CLEAR_ALL_UNSAVED_PRESENTATIONS',
)();

export const setUnsavedTheme = createStandardAction(
  '@PRESENTATION_PAGE/SET_UNSAVED_THEME',
)<Theme>();

export const clearUnsavedTheme = createStandardAction(
  '@PRESENTATION_PAGE/CLEAR_UNSAVED_THEME',
)<string>();

export const clearAllUnsavedThemes = createStandardAction(
  '@PRESENTATION_PAGE/CLEAR_ALL_UNSAVED_THEMES',
)();

export const setThemeSortOptions = createStandardAction(
  '@PRESENTATION_PAGE/SET_THEME_SORT_OPTIONS',
)<SortThemeOptions>();

export const setThemeSearchQuery = createStandardAction(
  '@PRESENTATION_PAGE/SET_THEME_SEARCH_QUERY',
)<string>();

// OAuth credential prefill (CX-4962). On a new deck, fetch + verify stored
// credentials and overlay them into empty OAuth props.
export const loadOAuthPrefill = createStandardAction(
  '@PRESENTATION_PAGE/LOAD_OAUTH_PREFILL',
)<{ applicationId: string; presentationProperties: PresentationProperty[] }>();

export const setOAuthPrefill = createStandardAction(
  '@PRESENTATION_PAGE/SET_OAUTH_PREFILL',
)<{ applicationId: string; propName: string; value: string }>();

// Freeze prefill for an app once the user has taken control of the form, so a
// user-cleared field is not re-overlaid.
export const markOAuthPrefillApplied = createStandardAction(
  '@PRESENTATION_PAGE/MARK_OAUTH_PREFILL_APPLIED',
)<{ applicationId: string }>();

// Marks the prefill GET+verify cycle as finished for an app (whether it found
// verified credentials or not). The form-edit freeze (markOAuthPrefillApplied)
// must wait for this: otherwise a programmatic onChange that fires before the
// async prefill lands would freeze the overlay and the credential would never
// be applied (a race the slower verify endpoints lose).
export const markOAuthPrefillResolved = createStandardAction(
  '@PRESENTATION_PAGE/MARK_OAUTH_PREFILL_RESOLVED',
)<{ applicationId: string }>();

export const clearOAuthPrefill = createStandardAction(
  '@PRESENTATION_PAGE/CLEAR_OAUTH_PREFILL',
)<{ applicationId: string }>();
